import { render, staticRenderFns } from "./ProviderCart.vue?vue&type=template&id=56a949c3&lang=pug&"
import script from "./ProviderCart.vue?vue&type=script&lang=js&"
export * from "./ProviderCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports